import React, { useEffect, useContext } from "react";
// import { useLoader } from "../Context/LoaderProvider.jsx";
import Aboutuscompomamat from "./Aboutuscompomamat";
import WhoweareBanner from "./WhoweareBanner";
import OurLeadership from "./OurLeadership";
import Ourjunery from "./Ourjunery";
import OurCommitments from "./OurCommitments";
import News from "./News"; 
// import Blogs from "./Blogs";
import Casestudy from "./Casestudy";
import Csr from "./Csr";
import Bottomtotop from "./Bottomtotop";


const Whatwedopage = () => {
 

  return (
    <div style={{ 
      // backgroundImage:"url('/image/3662a43d-artificial-intelligence.jpeg.optimal.jpeg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundAttachment: "fixed",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
      width: "100%"
    }}>
      <div style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}> 
        <WhoweareBanner/>
        <Aboutuscompomamat/>
        <OurLeadership/>
        <Ourjunery />
        <OurCommitments/>
        <News/>
        {/* <Casestudy/> */}
        {/* <Blogs/> */}
        <Csr/>
        <Bottomtotop/>
      </div>
    </div>
  );
};

export default Whatwedopage;
